module.exports = __webpack_public_path__ + "static/media/CreditCard.0030401b.svg";